import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, Button } from '@mui/material';
import MDTypography from 'components/MDTypography';
import MDBox from 'components/MDBox';

const priorityColors = {
  'Normal': 'success',
  'Needs Attention': 'warning',
  'Critical': 'error'
};

const getRowStyle = (priority) => {
  if (priority === 'Critical') return { borderLeft: '5px solid red', backgroundColor: '#FFEBEE' };
  if (priority === 'Needs Attention') return { borderLeft: '5px solid orange', backgroundColor: '#FFF3E0' };
  return { borderLeft: '5px solid green' };
};

const EscortTable = ({ escorts, onRowClick }) => {
  return (
    <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
      <Table>
        <TableHead sx={{ display: "table-header-group" }}>
          <TableRow>
            <TableCell>Priority</TableCell>
            <TableCell>User</TableCell>
            <TableCell>Type & State</TableCell>
            <TableCell>Activity</TableCell>
            <TableCell>Battery</TableCell>
            <TableCell>Movement</TableCell>
            <TableCell>Wellbeing Response</TableCell>
            <TableCell>Evidence</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {escorts.map((escort) => (
            <TableRow 
              key={escort.escortId} 
              sx={getRowStyle(escort.priority)}
              hover
            >
              <TableCell>
                <Chip label={escort.priority} color={priorityColors[escort.priority]} size="small" />
              </TableCell>
              <TableCell onClick={() => onRowClick(escort)} sx={{ cursor: 'pointer', color: 'blue' }}>
                <MDTypography variant="button" fontWeight="medium">{escort.user?.name || 'Unknown'}</MDTypography>
                <br />
                <MDTypography variant="caption" color="text">{escort.user?.phone}</MDTypography>
                <br />
                <MDTypography variant="caption" color="text">{escort.escortId}</MDTypography>
                {escort.isGsmMode && <Chip label="GSM" size="small" sx={{ ml: 1, height: 16, fontSize: 10 }} />}
              </TableCell>
              <TableCell>
                <MDTypography variant="caption" display="block">{escort.escortType}</MDTypography>
                <MDTypography variant="caption" color="text">{escort.userState}</MDTypography>
              </TableCell>
              <TableCell>
                <MDTypography variant="caption">{escort.activity}</MDTypography>
              </TableCell>
              <TableCell>
                <MDTypography variant="caption" color={escort.batteryLevel <= 15 ? 'error' : 'text'}>
                  {escort.batteryLevel}%
                </MDTypography>
              </TableCell>
              <TableCell>
                <MDTypography variant="caption">{escort.isMoving ? 'Moving' : 'Stopped'}</MDTypography>
              </TableCell>
              <TableCell>
                <MDTypography variant="caption" display="block">{escort.wellbeingResponse}</MDTypography>
                {escort.wellbeingCheckSource && (
                  <MDTypography variant="caption" color="text" display="block">
                    {escort.wellbeingCheckSource}
                  </MDTypography>
                )}
                {escort.wellbeingPushStatus && (
                  <MDTypography variant="caption" color={escort.wellbeingPushStatus === 'Failed' ? 'error' : 'text'}>
                    ({escort.wellbeingPushStatus})
                  </MDTypography>
                )}
              </TableCell>
              <TableCell>
                <Button size="small" disabled={!escort.vehicleImage}>
                  {escort.vehicleImage ? 'Open File' : 'No File'}
                </Button>
              </TableCell>
              <TableCell>
                <Button variant="contained" size="small" onClick={() => onRowClick(escort)}>
                  Action
                </Button>
              </TableCell>
            </TableRow>
          ))}
          {escorts.length === 0 && (
            <TableRow>
              <TableCell colSpan={9} align="center">
                <MDTypography variant="button" color="text">No active escorts found.</MDTypography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default EscortTable;
